import { statusKeys } from '../../helpers/projReportHelper';
import { isAdmin } from '../../services/rolesSvc';

export const getIsExpert = (userPerms) => userPerms.includes('techAdmin') || userPerms.includes('projManagement');

export const getIsResultsReadOnly = (userCanEdit, userCtx, reportStatus) => {
  const isExpert = isAdmin(userCtx);

  if (!userCanEdit) return true;

  return reportStatus === statusKeys.onApproveExperts && !isExpert || reportStatus === statusKeys.expertsApproved || reportStatus === statusKeys.expertsDeclined;

  // switch (reportStatus) {
  //   case statusKeys.inProgress:
  //     return false;
  //   case statusKeys.onApproveExperts:
  //     return !isExpert;
  //   case statusKeys.returnedByPortf:
  //     return false;
  //   case statusKeys.expertsApproved:
  //   case statusKeys.expertsDeclined:
  //   default:
  //     return true;
  // }
};

export const getExpertCardParams = (userCtx, reportStatus) => {
  const isExpert = !!isAdmin(userCtx);

  // форма отображается для всех, если решение уже вынесено
  let show = [statusKeys.expertsApproved, statusKeys.expertsDeclined, statusKeys.approved].includes(reportStatus);
  let readOnly = show; // если форма readOnly, вынесение решения недоступно
  let canEdit = false; // ПО всегда может редактировать решение

  // если отчет на рассмотрении ЭГ, ПО выносит решение
  if (isExpert && reportStatus === statusKeys.onApproveExperts) {
    show = true;
    readOnly = false;
  }

  canEdit = show && isExpert; // ПО может редактировать решение всегда, когда доступна форма

  return { show, readOnly, canEdit };
};
